import {Link} from "react-router-dom";
import {Col, Row} from "antd";

const Forbidden = () => {
    return (
        <Row align={"middle"} justify={"center"}>
            <Col span={24}>
                <h1 style={{textAlign: "center"}}>403</h1>
                <h3 style={{textAlign: "center"}}>You do not have permission to access the document or program that you
                    requested</h3>
                <p style={{textAlign: "center"}}><Link to="/sign-in">Sign In</Link></p>
            </Col>
        </Row>
    )
}

export default Forbidden;
